import { postApi, deleteApi, putApi } from "../apiCall";

export const addUser = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/create`;
  return postApi(url, payload);
};

export const addUserPermission = (userId, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/users/${userId}/add-permissions`;
  return postApi(url, payload);
};

export const removeUserPermissions = (userId, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/users/${userId}/remove-permissions`;
  return deleteApi(url, payload, {}, false);
};
export const assignToEntity = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/assign-to-entity`;
  return postApi(url, payload, {}, false);
};
export const unassignToEntity = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/unassign-from-entity`;
  return deleteApi(url, payload, {}, false);
};

export const addConsumer = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/consumerDetails/create`;
  return postApi(url, payload);
};

export const addGenerator = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/create`;
  return postApi(url, payload);
};

export const updateConsumer = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/consumerDetails/update`;
  return putApi(url, payload);
};

export const updateGenerator = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/update`;
  return putApi(url, payload);
};

export const changeConsumerActiveStatus = (consumerId, status) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/consumerDetails/changeActiveStatus/${consumerId}?status=${status}`;
  return deleteApi(url, null, {}, false);
};

export const changeGeneratorActiveStatus = (generatorId, status) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/changeActiveStatus/${generatorId}?status=${status}`;
  return deleteApi(url, null, {}, false);
};

export const updateUser = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/user/update`;
  return putApi(url, payload);
};

export const deleteUser = (userId) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/user/delete/${userId}`;
  return deleteApi(url, null, {}, false);
};

export const changeUserActiveStatus = (userId, status) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/changeActiveStatus/${userId}?status=${status}`;
  return deleteApi(url, null, {}, false);
};

export const generateMemberDetails = (formData) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/report/html`;
  return postApi(url, formData);
};

export const updateMemberDetails = (formData) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/member-details`;
  return postApi(url, formData);
};

export const getMemberDetails = (formData, id) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/member-details/${id}`;
  return postApi(url, formData);
};
